'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.signup = void 0;
var adapter_1 = require("../adapter");
var Signup = /** @class */ (function () {
    function Signup() {
    }
    /**
     * Gets the enabled countries.
     */
    Signup.prototype.getCurrencies = function () {
        return adapter_1.adapter.signup.getCurrencies();
    };
    /**
     * Gets the available verification types for the user's ip. User Verification types can be whitelisted for each country.
     */
    Signup.prototype.registrationTypes = function () {
        return adapter_1.adapter.signup.registrationTypes();
    };
    /**
     * Returns the default options for sign up, for example the country the user is in.
     */
    Signup.prototype.getRegDDLists = function () {
        return adapter_1.adapter.signup.getRegDDLists();
    };
    /**
     * Checks if the given email is available.
     */
    Signup.prototype.checkEmail = function (params) {
        return adapter_1.adapter.signup.checkEmail(params);
    };
    /**
     * Get for the Buenos Aires Gambling Law, the predefined list of occupations.
     */
    Signup.prototype.getOccupations = function (lang) {
        var params = { lang: lang };
        return adapter_1.adapter.signup.getOccupations(params);
    };
    /**
     * Get for the occupations for a given regulator
     * Returned values are plain strings, not translation slugs
     * Currently, it supports `agco`
     */
    Signup.prototype.getOccupationsByRegulation = function (regulatorAcronym) {
        var params = { regulatorAcronym: regulatorAcronym };
        return adapter_1.adapter.signup.getOccupationsByRegulation(params);
    };
    /**
     * Returns the list of countries used to populate the nationality field on the sign up flow
     * Currently used only for Buenos Aires Gambling Law
     */
    Signup.prototype.getNationalities = function () {
        return adapter_1.adapter.signup.getNationalities();
    };
    /**
     * Checks if the given username is available.
     */
    Signup.prototype.checkUsername = function (params) {
        return adapter_1.adapter.signup.checkUsername(params);
    };
    /*
     *   Returns the list of subdivisions for the given country
     */
    Signup.prototype.getSubdivisions = function (params) {
        return adapter_1.adapter.signup.getSubdivisions(params);
    };
    /*
     * Returns the list of industries for the given country
     */
    Signup.prototype.getIndustries = function () {
        return adapter_1.adapter.signup.getIndustries();
    };
    /*
     *   New Zealand address and postcode finder
     */
    Signup.prototype.addressFinder = function (params) {
        return adapter_1.adapter.signup.addressFinder(params);
    };
    /*
     *   Metadata for a given address id
     */
    Signup.prototype.addressFinderMetadata = function (params) {
        return adapter_1.adapter.signup.addressFinderMetadata(params);
    };
    /**
     * Returns a list of PEP Source of Wealth
     */
    Signup.prototype.getPepSourceOfWealth = function () {
        return adapter_1.adapter.signup.getPepSourceOfWealth();
    };
    /**
     * Returns a list of PEP Source of Funds
     */
    Signup.prototype.getPepSourceOfFunds = function () {
        return adapter_1.adapter.signup.getPepSourceOfFunds();
    };
    /**
     * Returns a list of PEP Categories
     */
    Signup.prototype.getPepCategories = function () {
        return adapter_1.adapter.signup.getPepCategories();
    };
    return Signup;
}());
exports.signup = new Signup();
